
import l10njs from 'l10n.js';

function _ (string) {
    'use strict';

    return string.toLocaleString();
}
 
function localizeHTMLTag(tagId, useLabel) {
    'use strict';
    let tag = document.getElementById(tagId);
    if (tag && tag.src) {
        tag.title = _(tag.title);
    } else {
        if (!useLabel) {
        tag.innerHTML = _(tag.innerHTML);
    } else {
        tag.innerHTML = _(useLabel);
    }
    }
}

/* To replace the structure <span translate="XX"></span> by the corresponding translation of the text with ID=XX */
function translateAll() {
    var translationAttribute  = "translate";
	$('span['+translationAttribute+']').each(function(idx){

        // get the value of the attribute.
        var translateId = $(this).attr(translationAttribute);
        var translatedValue = _(translateId);

        if(translatedValue === undefined){
            console.log("Translation for "+ translateId + " not found.");
        }

        // now replace the span's text with the translation:
        $(this).html(translatedValue);
    });
}
 
function getParameterValue(parameter) {
    'use strict';
    parameter = parameter.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    let regexS = "[\\?&]" + parameter + "=([^&#]*)";
    let regex = new RegExp(regexS);
    let results = regex.exec(window.location.href);
    if(results === null) {
        return '';
    } else {
        return results[1];
    }
        
}

export {
    _,
    localizeHTMLTag,
    getParameterValue,
    translateAll
};